import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  textStyle: {
    editor: 'textbox',
    default: '',
  },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A simple h1 element with various attributes',
  coreComponent_v3: {
    html: `<tag3-h1 {{...knobs}} >Some interesting text...</tag3-h1>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3H1 {{...knobs}} >Some interesting text...</Tag3H1>`,
    knobs: {
      ...PlaygroundKnobs,
      textStyle: { ...PlaygroundKnobs.textStyle, qualifierEnd: '}', qualifierStart: '{' },
    },
  },
};

const CustomStylesStory: Story = {
  title: 'Custom Styles',
  description: 'How to override styles using text-style prop',
  coreComponent_v3: {
    html: `<tag3-h1{{...knobs}}>Custom styled text...</tag3-h1>`,
    knobs: {
      textStyle: {
        editor: 'textbox',
        default: '{"font-size":"16px", "font-weight":"700"}',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<Tag3H1{{...knobs}}>Custom styled text...</Tag3H1>`,
    knobs: {
      textStyle: {
        editor: 'textbox',
        default: '{fontSize:"16px", fontWeight:"700"}',
        qualifierEnd: '}',
        qualifierStart: '{',
      },
    },
  },
};

export const TagH1Docs: Component = {
  type: 'component',
  name: 'h1',
  description: 'Renders a h1 element',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'accent',
      description: 'The colour of the text',
      type: 'string',
    },
    {
      name: 'textStyle',
      description: 'JSX style object in JSON to apply to the text',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory, CustomStylesStory],
};
